import React from 'react';

const Card = ({ 
  children, 
  title, 
  subtitle,
  style = {},
  ...props 
}) => {
  const cardStyle = {
    background: 'white',
    borderRadius: '20px',
    padding: '40px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
    ...style
  };

  const titleStyle = {
    fontSize: '2.5rem',
    fontWeight: 'bold',
    color: '#374151',
    marginBottom: '20px',
    textAlign: 'center',
  };

  const subtitleStyle = {
    fontSize: '1.1rem',
    color: '#666',
    lineHeight: '1.6',
    marginBottom: '40px',
    textAlign: 'center',
  };

  return (
    <div style={cardStyle} {...props}>
      {title && <h1 style={titleStyle}>{title}</h1>}
      {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
      {children}
    </div>
  );
};

export default Card;
